// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  versonaId: __t.u64().primaryKey().name("versona_id"),
  warId: __t.u64().name("war_id"),
  worldId: __t.u64().name("world_id"),
  kind: __t.string(),
  refId: __t.u64().name("ref_id"),
  side: __t.string(),
  sinceAt: __t.timestamp().name("since_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
